import Milestone from '@/models/Milestone'
import Paginator from '@/models/Paginator'
import { project as backend } from '@/api'

export default {

  namespaced: true,

  state: {
    milestone: new Milestone,
    milestones: new Paginator
  },

  mutations: {
    setMilestone: (state, payload) => state.milestone = payload,
    setMilestones: (state, payload) => state.milestones = payload,
    title: (state, payload) => state.milestone.title = payload,
    dueDate: (state, payload) => state.milestone.due_date = payload,
    setTasks: (state, payload) => state.milestone.tasks = payload,
    clear: (state) => state.milestone = new Milestone,
  },

  actions: {
    storeMilestone: ({state}, project) => new Promise((resolve, reject) => {
      let milestone = {...state.milestone}

      milestone.tasks = milestone.tasks.map(task => task.id)

      backend.storeMilestone({
        project,
        ...milestone
      }, resolve, reject)
    }),

    deleteMilestone: ({}, milestoneId) => new Promise((resolve, reject) => {
      backend.deleteMilestone(milestoneId, resolve, reject) 
    }),
    updateTitle: ({}, payload) => new Promise((resolve, reject) => {
      backend.updateMilestoneTitle(payload, resolve, reject) 
    }),
    updateDueDate: ({}, payload) => new Promise((resolve, reject) => {
      backend.updateMilestoneDueDate(payload, resolve, reject) 
    }),
    markAsComplete: ({}, milestoneId) => new Promise((resolve, reject) => {
      backend.markMilestoneComplete(milestoneId, resolve, reject) 
    }),
    reopenMilestone: ({}, milestoneId) => new Promise((resolve, reject) => {
      backend.reopenMilestone(milestoneId, resolve, reject) 
    })
  },

  getters: {
    milestone: state => state.milestone
  }

}